angular.module('filters')
    .filter('normalizeForTranslate', () => (input) => {

        if (input) {

            return input.replace(/-/g, '_');

        }
        return false;

    });



// WEBPACK FOOTER //
// ./scripts/filters/normalizeForTranslate.js